var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasShops)?_c('div',{staticClass:"content"},[_c('h2',{staticClass:"is-size-6 has-text-centered"},[_vm._v("対象店舗")]),_c('ul',_vm._l((_vm.shops),function(shop){return _c('li',{key:shop.id},[_vm._v(_vm._s(shop.name))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }